export function MethodRow({ label, value }: { label: string; value: string }) {
  return (
    <div className="break-words">
      <span className="font-semibold">{label}:</span>{" "}
      <span className="text-muted-foreground">{value}</span>
    </div>
  );
}
